'use client';

import type { ReactNode } from 'react';
import styled from 'styled-components';

import type { BlockTemplate } from '@zoomit/editor';
import type { ValueOf } from '@zoomit/primitives';
import { Breakpoints } from '@zoomit/primitives';

import { getBlockContainerType } from '../../../helpers/article/blocks';

type ContainerVariant = 'small' | 'medium';

type Props = {
  children: ReactNode;
  containerVariant?: ContainerVariant;
  template?: ValueOf<BlockTemplate>;
};

export const BlockContainer = (props: Props) => {
  const { children, template, containerVariant = 'small' } = props;
  return (
    <Root $isSmall={getBlockContainerType(template) === 'small'} containerVariant={containerVariant}>
      {children}
    </Root>
  );
};

const Root = styled.div<{ $isSmall: boolean; containerVariant: ContainerVariant }>`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;
  margin: 0 auto;

  max-width: ${({ $isSmall, containerVariant }) =>
    $isSmall ? (containerVariant === 'small' ? '468px' : '568px') : '100%'};

  @media (min-width: ${Breakpoints.lg}) {
    max-width: ${({ $isSmall, containerVariant }) =>
      $isSmall ? (containerVariant === 'small' ? '760px' : '878px') : '100%'};
  }
`;
